var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#4173CD"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("rect", {
    y: 341.33,
    style: {
      fill: "#4173CD"
    },
    width: 512,
    height: 170.67
  })), /*#__PURE__*/React.createElement("rect", {
    y: 170.67,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M257.948,233.988l4.822,14.458l15.241,0.118c1.973,0.015,2.791,2.533,1.204,3.706l-12.261,9.054   l4.597,14.531c0.595,1.881-1.547,3.438-3.152,2.29l-12.4-8.863l-12.399,8.863c-1.605,1.147-3.747-0.409-3.152-2.29l4.597-14.531   l-12.261-9.054c-1.587-1.172-0.769-3.69,1.204-3.706l15.241-0.118l4.822-14.458C254.676,232.116,257.324,232.116,257.948,233.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M120.316,272.792l4.822,14.458l15.241,0.118c1.973,0.015,2.791,2.533,1.204,3.706l-12.261,9.054   l4.597,14.531c0.595,1.881-1.547,3.438-3.152,2.29l-12.399-8.863l-12.399,8.863c-1.605,1.147-3.747-0.409-3.152-2.29l4.597-14.531   l-12.261-9.054c-1.587-1.172-0.769-3.69,1.204-3.706l15.241-0.118l4.822-14.458C117.044,270.92,119.692,270.92,120.316,272.792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M120.316,195.184l4.822,14.458l15.241,0.118c1.973,0.015,2.791,2.533,1.204,3.706l-12.261,9.054   l4.597,14.531c0.595,1.881-1.547,3.438-3.152,2.29l-12.399-8.863l-12.399,8.863c-1.605,1.147-3.747-0.409-3.152-2.29l4.597-14.531   l-12.261-9.054c-1.587-1.172-0.769-3.69,1.204-3.706l15.241-0.118l4.822-14.458C117.044,193.312,119.692,193.312,120.316,195.184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M395.58,272.792l4.822,14.458l15.241,0.118c1.973,0.015,2.791,2.533,1.204,3.706l-12.261,9.054   l4.597,14.531c0.595,1.881-1.547,3.438-3.152,2.29l-12.4-8.863l-12.4,8.863c-1.605,1.147-3.747-0.409-3.152-2.29l4.597-14.531   l-12.261-9.054c-1.587-1.172-0.769-3.69,1.204-3.706l15.241-0.118l4.822-14.458C392.308,270.92,394.956,270.92,395.58,272.792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M395.58,195.184l4.822,14.458l15.241,0.118c1.973,0.015,2.791,2.533,1.204,3.706l-12.261,9.054   l4.597,14.531c0.595,1.881-1.547,3.438-3.152,2.29l-12.4-8.863l-12.4,8.863c-1.605,1.147-3.747-0.409-3.152-2.29l4.597-14.531   l-12.261-9.054c-1.587-1.172-0.769-3.69,1.204-3.706l15.241-0.118l4.822-14.458C392.308,193.312,394.956,193.312,395.58,195.184z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHn);
export default __webpack_public_path__ + "static/media/hn.27ebe07b2c3f8ec22444fe9f128cbc06.svg";
export { ForwardRef as ReactComponent };